/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = [''];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3Zhci93d3cvZG5hdGEtY2VyZi1mcm9udC1lbmQvcmVsZWFzZXMvMjAyMDAzMjYxNjEyMzMvc3JjL2FwcC9tb2R1bGVzL2ZpZWxkcy9jb21wb25lbnRzL2NhbGN1bGF0aW9uLWZpZWxkL2NhbGN1bGF0aW9uLWZpZWxkLmNvbXBvbmVudC5zY3NzLnNoaW0ubmdzdHlsZS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL3Zhci93d3cvZG5hdGEtY2VyZi1mcm9udC1lbmQvcmVsZWFzZXMvMjAyMDAzMjYxNjEyMzMvc3JjL2FwcC9tb2R1bGVzL2ZpZWxkcy9jb21wb25lbnRzL2NhbGN1bGF0aW9uLWZpZWxkL2NhbGN1bGF0aW9uLWZpZWxkLmNvbXBvbmVudC5zY3NzIl0sInNvdXJjZXNDb250ZW50IjpbIiAiXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7OzsifQ==



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/$$_gendir/app/modules/fields/components/calculation-field/calculation-field.component.scss.shim.ngstyle.ts